import { arraySwap } from "@dnd-kit/sortable";

export default function permute({ array, from, to, lockedArr = undefined }) {
  // Not mute
  if (from === to) {
    return [...array];
  }

  const lefty = from - to > 0;
  const increment = lefty ? -1 : 1;

  if (lockedArr === undefined) {
    lockedArr = array.map(false);
  }

  // Little recursion to cut end if element is locked
  // Can skip muting if all neighbour elements are locked
  if (lockedArr[to]) {
    to = to - increment;
    return permute({ array, from, to, lockedArr });
  }

  let newArray = [...array];

  let activeIndex = from;
  let stepSize = 0;

  while (activeIndex !== to) {
    stepSize += increment;
    const overIndex = activeIndex + stepSize;

    if (lockedArr[overIndex]) {
      continue;
    } else {
      newArray = arraySwap(newArray, activeIndex, overIndex);
      activeIndex = overIndex;
      stepSize = 0;
    }
  }

  return newArray;
}
